module.exports = __webpack_public_path__ + "static/media/step1.1d93ab67.png";